export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total a debitar"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comissão"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Info"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A creditar"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossível calcular o valor"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fundos insuficientes para o pagamento"])}
}